import Keyboard, { KeyboardReactInterface } from "react-simple-keyboard";
import React, { ChangeEventHandler, useRef, useState } from "react";
import "./AdminLoginKeyboard.scss";
import Input from "./Input";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import SvgIcon from "@mui/material/SvgIcon";
interface KeyboardProps {
    type?: string;
    layoutName?: string;
    onClick: () => void;

    onKeyPress: any;
    driverNameInput?: string;
    titleDec?: string;
}

const KeyboardWrap: React.FC<KeyboardProps> = ({
    type,
    onClick,
    onKeyPress,
    layoutName,
    driverNameInput,
    titleDec,
}) => {
    const keyboardRef = useRef<KeyboardReactInterface | null>(null);

    const theme =
        type === "text"
            ? "hg-theme-default hg-theme-ios"
            : " hg-theme-default hg-theme-number";
    const textLayout = {
        default: [
            "1 2 3 4 5 6 7 8 9 0",
            "q w e r t y u i o p",
            "a s d f g h j k l",
            "{shift} z x c v b n m {bksp}",
        ],
        shift: [
            "1 2 3 4 5 6 7 8 9 0",
            "Q W E R T Y U I O P",
            "A S D F G H J K L",
            "{shiftactivated} Z X C V B N M {bksp}",
        ],
    };

    const numberLayout = {
        default: ["1 2 3", "4 5 6", "7 8 9", "지우기 0 재입력"],
    };
    const display = {
        "{alt}": ".?123",
        "{smileys}": "\uD83D\uDE03",
        "{shift}": "⇧",
        "{shiftactivated}": "⇧",
        "{enter}": "return",
        "{bksp}": "⌫",
        "{altright}": ".?123",
        "{downkeyboard}": "🞃",
        "{space}": " ",
        "{default}": "ABC",
        "{back}": "⇦",
    };

    return (
        <>
            <div
                style={{
                    position: "fixed",
                    width: "100%",
                    bottom: "5%",
                    zIndex: "9999",
                    background: "#3c404a",
                }}
            >
                <div className="keyboard-input-wrap">
                    <div className="keyboard-title-wrap">
                        <span>{titleDec}</span>
                    </div>
                </div>
                <Keyboard
                    keyboardRef={(r) => (keyboardRef.current = r)}
                    layout={textLayout}
                    display={display}
                    onKeyPress={onKeyPress}
                    theme={theme}
                    layoutName={layoutName}
                ></Keyboard>
                <div className="admin-keyboard-btn-wrap">
                    <button
                        style={{
                            fontSize: "3em",
                            border: "none",
                            borderRadius: "0.3em",
                            padding: "0.5em",
                        }}
                        onClick={() => {
                            onClick();
                        }}
                    >
                        확인
                    </button>
                </div>
            </div>
        </>
    );
};

export default KeyboardWrap;
